import { Box, Skeleton } from '@mui/material'
import styled from 'styled-components'
import { ICustomerSummary } from '../../Models/Customer'

const List = styled.div`
    display: flex;
    gap:10px;
    flex-wrap:wrap;
`

const Item = styled.div`
    display: flex;
    padding: 10px;
    flex-direction: column;
    background: #f1f1f1;
    // max-width: 200px;
    // width: calc(25% - 10px);
    min-width:fit-content;
    border-radius: 4px;
`

const ItemLabel = styled.span`
    font-size: 14px;
    font-weight: 600;
`

const ItemValue = styled.span`
    font-size: 12px;
`

type THighlightsCardProps = {
    customerDetails?: ICustomerSummary;
    fields: {
        label: any;
        value: any;
    }[]
}

const HighlightsCard = (props: THighlightsCardProps) => {

    const { fields, customerDetails } = props

    const SkeletonBar = () => {
        return (
            <Box sx={{ width: 150 }}>
              <Skeleton />
              <Skeleton animation="wave" />
              <Skeleton animation={false} />
            </Box>
        );
    }

    return (
        customerDetails ?
            Object.keys(customerDetails as ICustomerSummary).length
                ?<List>
                        {fields.map((summary) => {
                            return (
                                <Item key={summary.label}>
                                    <ItemLabel><span>{summary.label}</span></ItemLabel>
                                    <ItemValue><span>{summary.value}</span></ItemValue>
                                </Item>
                            )
                        })}
                </List>
                : <List>
                    {fields.map(_ => <SkeletonBar/> )}
                </List> 
            : null
    )
}

export default HighlightsCard